<template>
  <div id="app">
    <router-view v-if="isRouterAlive"></router-view>
    <!-- <div class="loading-container" v-if="isLoading">
      <div class="loader">
        <span class="text">Loading</span>
        <span class="spinner"></span>
      </div>
    </div> -->
  </div>
</template>

<script>
export default {
  name: "App",
  provide() {
    return {
      reload: this.reload
    };
  },
  data() {
    return {
      isRouterAlive: true,
      isLoading: true
    };
  },
  mounted() {
    var _this = this;
    // let path = this.$route.fullPath.replace("/m", "");
    // path = path === "/" ? "" : path;
    // if (this.isMobile()) {
    //   this.$router.push("/m" + path);
    // } else {
    //   this.$router.push(path);
    // }
    setTimeout(function(){
      _this.isLoading = false;
    }, 2000);
  },
  methods: {
    isMobile() {
      let flag = navigator.userAgent.match(
        // match方法可在字符串内检索指定的值，
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      // console.log(flag)
      return flag;
    },
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function() {
        this.isRouterAlive = true;
      });
    }
  }
};
</script>

<style lang="scss">
@import "./assets/scss/loading.scss";
#app {
  font-family: "Helvetica Neue", "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  position: relative;
}
*:focus{
  outline: none;
}
.loading-container {
  background: #ffffff;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/App.vue